import { render, staticRenderFns } from "./ComponentsCatalog.vue?vue&type=template&id=d56e4dc4&scoped=true&"
import script from "./ComponentsCatalog.vue?vue&type=script&lang=js&"
export * from "./ComponentsCatalog.vue?vue&type=script&lang=js&"
import style0 from "./ComponentsCatalog.vue?vue&type=style&index=0&id=d56e4dc4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d56e4dc4",
  null
  
)

component.options.__file = "ComponentsCatalog.vue"
export default component.exports